import GiftRedemptionListPanel from "./giftRedemptionListPanel.container"

export default GiftRedemptionListPanel
